import { FundingLandingLayout } from '@src/components/sco/Funding/layout/FundingLayout'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'

export { getServerSideProps } from '@src/lib/server-side-rendering'

/**
 * Funding entry: guests and registered users without a fundraise see the landing.
 * Registered users with an existing investor search are redirected into matching.
 *
 * SEO is set here (not only in the gated landing section) so the initial SSR HTML
 * has the correct title/description while SSRGate holds the body.
 */
export default function Page() {
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('funding.landing')
    activeContent.setItem({
      __typename: 'LandingPage',
      title: 'Raise Capital 10x Faster',
      description:
        'Automate your fundraise with AI investor matching and outreach. Match with verified investors, perfect your pitch, and track every email in one place.',
    })
    return () => activeContent.setItem(null)
  }, [])

  return <FundingLandingLayout />
}
